import React from 'react';

import { ErrorPageFallback } from 'shared/presentation/components/organisms';
import { ICONS } from 'shared/presentation/constants';
import { useLocale, useNavigation } from 'shared/presentation/contexts';

import PageWrapper from '../PageWrapper';

interface IRecognitionErrorProps {
  error: string;
}

const RecognitionError: React.FC<IRecognitionErrorProps> = ({ error }) => {
  const { t } = useLocale('shared');
  const navigation = useNavigation();

  return (
    <PageWrapper>
      <ErrorPageFallback
        title={t('Ops something went wrong!')}
        message={error}
        actions={[
          {
            text: t('Try again'),
            icon: ICONS.REFRESH,
            onClick: () => navigation.refresh(),
          },
        ]}
      />
    </PageWrapper>
  );
};

export default RecognitionError;
